if (!window.__carouselCardsInit) {
  window.__carouselCardsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    [].forEach.call(document.querySelectorAll('[data-car]'), function (root) {
      var sec = root.closest('section') || document;
      var track = root.querySelector('[data-track]');
      var slides = [].slice.call(track.querySelectorAll('.carousel-cards__slide'));
      if (!slides.length) return;

      var ctl = sec.querySelector('[data-ctl]');
      var nav = sec.querySelector('[data-nav]');
      if (!ctl || !nav) return;

      var prev = sec.querySelector('[data-prev]');
      var next = sec.querySelector('[data-next]');
      var dotWrap = sec.querySelector('[data-dots]');
      var cur = sec.querySelector('[data-cur]');
      var tot = sec.querySelector('[data-total]');
      var base = slides[0].offsetLeft;
      var stops = [];

      ctl.hidden = false;
      nav.hidden = false;

      function reduce() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      function measure() {
        base = slides[0].offsetLeft;
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        stops = [];
        for (var i = 0; i < slides.length; i++) {
          var x = Math.min(slides[i].offsetLeft - base, max);
          if (!stops.length || Math.abs(x - stops[stops.length - 1]) > 4) stops.push(x);
        }
        if (!stops.length) stops = [0];
        if (dotWrap.children.length !== stops.length) {
          dotWrap.innerHTML = '';
          for (var k = 0; k < stops.length; k++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'carousel-cards__dot';
            d.dataset.goto = k;
            d.setAttribute('aria-label', 'Go to position ' + (k + 1) + ' of ' + stops.length);
            d.addEventListener(
              'click',
              (function (n) {
                return function () {
                  go(n);
                };
              })(k)
            );
            dotWrap.appendChild(d);
          }
        }
        tot.textContent = slides.length;
      }

      function index() {
        var best = 0;
        var bd = Infinity;
        for (var i = 0; i < stops.length; i++) {
          var d = Math.abs(stops[i] - track.scrollLeft);
          if (d < bd - 1) {
            bd = d;
            best = i;
          }
        }
        return best;
      }

      function currentSlideIndex() {
        var best = 0;
        var bd = Infinity;
        for (var i = 0; i < slides.length; i++) {
          var d = Math.abs(slides[i].offsetLeft - base - track.scrollLeft);
          if (d < bd - 1) {
            bd = d;
            best = i;
          }
        }
        return best;
      }

      function go(i) {
        i = Math.max(0, Math.min(stops.length - 1, i));
        track.scrollTo({ left: stops[i], behavior: reduce() ? 'auto' : 'smooth' });
      }

      function sync() {
        var i = index();
        cur.textContent = currentSlideIndex() + 1;
        var kids = dotWrap.children;
        for (var k = 0; k < kids.length; k++) {
          var on = k === i;
          kids[k].classList.toggle('is-on', on);
          kids[k].setAttribute('aria-current', on ? 'true' : 'false');
        }
        prev.disabled = i === 0;
        next.disabled = i === stops.length - 1;
      }

      function refresh() {
        measure();
        sync();
      }

      prev.addEventListener('click', function () {
        go(index() - 1);
      });
      next.addEventListener('click', function () {
        go(index() + 1);
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          go(index() + 1);
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          go(index() - 1);
        }
      });

      var t;
      track.addEventListener(
        'scroll',
        function () {
          clearTimeout(t);
          t = setTimeout(sync, 70);
        },
        { passive: true }
      );

      var isDragging = false;
      var dragMoved = false;
      var dragPointerId = null;
      var dragStartX = 0;
      var dragStartScroll = 0;
      var DRAG_THRESHOLD = 4;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDragging = false;
        dragMoved = false;
        dragPointerId = e.pointerId;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
      });

      track.addEventListener('pointermove', function (e) {
        if (dragPointerId === null || e.pointerId !== dragPointerId) return;
        var dx = e.clientX - dragStartX;
        if (!isDragging) {
          if (Math.abs(dx) < DRAG_THRESHOLD) return;
          isDragging = true;
          dragMoved = true;
          track.classList.add('is-dragging');
          try {
            track.setPointerCapture(dragPointerId);
          } catch (err) {
            /* no-op */
          }
        }
        track.scrollLeft = dragStartScroll - dx;
      });

      function endDrag() {
        if (isDragging) {
          track.classList.remove('is-dragging');
          go(index());
        }
        isDragging = false;
        dragPointerId = null;
      }

      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener(
        'click',
        function (e) {
          if (dragMoved) {
            e.preventDefault();
            e.stopPropagation();
            dragMoved = false;
          }
        },
        true
      );

      var r;
      window.addEventListener('resize', function () {
        clearTimeout(r);
        r = setTimeout(refresh, 150);
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(refresh);
      }

      refresh();
    });
  });
}
